import React from "react";
import { Link } from "gatsby";
import { FaMapMarkerAlt } from "react-icons/fa";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import "./styles.scss";
import SocialLinks from "../SocialLinks";

function Footer() {
	return (
		<footer className="section section--is-dark footer">
			<div className="container">
				<div className="footer__grid">
					<div className="footer__contact">
						<h2 className="footer__contact-heading">
							Got a Project?
							<Link to="/contact">
								Let's Talk!
								<HiOutlineArrowNarrowRight aria-hidden="true" size={32} />
							</Link>
						</h2>
						<div className="footer__contact-methods">
							<div>
								<a href={`tel:612-200-1015`}>612-200-1015</a>
							</div>
							<div>
								<a href={`mailto:info@irishtitan.com`}>info@irishtitan.com</a>
							</div>
						</div>
					</div>
					<div className="footer__links">
						<ul className="footer__site-nav">
							<li>
								<Link to="/contact">Contact</Link>
							</li>
							<li>
								<Link to="/news">News</Link>
							</li>
							<li>
								<Link to="/careers">Careers</Link>
							</li>
							<li>
								<Link to="/support">Support</Link>
							</li>
							<li>
								<a href="https://mxmerchant.com/mxcustomer/d/1f8a2361-a703-4da1-9ad8-288183b0cd2c/v3">
									Payments
								</a>
							</li>
						</ul>
						<SocialLinks classModifier={`social-links__footer`} />
					</div>
					<div className="footer__crust">
						<a
							rel="noreferrer"
							target="_blank"
							href="https://goo.gl/maps/fu515z8AYDmcKEyU7"
							className="footer__address"
						>
							<FaMapMarkerAlt title={`Get directions to Irish Titan`} size={20} />
							<div>5320 W 23rd Street</div>
							<div>Suite 300</div>
							<div>
								Minneapolis, MN 55416
							</div>
						</a>
						<ul className="footer__legal">
							<li>
								<Link to="/privacy">Privacy Statement</Link>
							</li>
							<li>
								<Link to="/accessibility">ADA Compliance</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
